import { render } from "./TvmSuggestions.vue?vue&type=template&id=1558b88c&scoped=true"
import script from "./TvmSuggestions.js?vue&type=script&lang=js&external"
export * from "./TvmSuggestions.js?vue&type=script&lang=js&external"

import "./TvmSuggestions.vue?vue&type=style&index=0&id=1558b88c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1558b88c"],['__file',"src/components/ChatWidget/TvmSuggestions/TvmSuggestions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1558b88c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1558b88c', __exports__)) {
    api.reload('1558b88c', __exports__)
  }
  
  module.hot.accept("./TvmSuggestions.vue?vue&type=template&id=1558b88c&scoped=true", () => {
    api.rerender('1558b88c', render)
  })

}


export default __exports__